export default "__VITE_ASSET__XWT8kNQ7__"